module.exports = __webpack_public_path__ + "static/hotelkima-de9b419330921382bc17c156616ecf4c.jpg";